<template>
  <v-snackbar
    v-model="show"
    :color="model.color"
    :timeout="5000"
    location="top right"
    class="modern-toast"
    elevation="8"
  >
    <div class="toast-content">
      <div class="toast-icon-wrapper" :class="`toast-${model.color}`">
        <v-icon :color="model.iconColor" size="20">{{ model.icon }}</v-icon>
      </div>
      <div class="toast-text">
        <div class="toast-title">{{ model.title }}</div>
        <div class="toast-message">{{ snackbar.message }}</div>
      </div>
      <v-btn
        icon
        size="small"
        variant="text"
        @click="show = false"
        class="toast-close"
      >
        <v-icon size="18">mdi-close</v-icon>
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: "Toaster",
  props: {
    snackbar: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      model: {
        visible: false,
        color: "success",
        title: "Succes!",
        message: "",
        icon: "mdi-check-circle",
        iconColor: "white",
        code: 200
      },
      Types: [
        {
          Code: 200,
          Color: "success",
          Title: "Succes!",
          Icon: "mdi-check-circle",
          IconColor: "#4CAF50"
        },
        {
          Code: 401,
          Color: "error",
          Title: "Eroare!",
          Icon: "mdi-alert-circle",
          IconColor: "#f44336"
        },
        {
          Code: 400,
          Color: "warning",
          Title: "Atenție!",
          Icon: "mdi-alert",
          IconColor: "#ff9800"
        },
        {
          Code: 0,
          Color: "info",
          Title: "Informație",
          Icon: "mdi-information",
          IconColor: "#2196F3"
        }
      ]
    }
  },

  computed: {
    show: {
      get() {
        this.setSnackbar()
        return this.snackbar.visible
      },
      set(value: any) {
        this.$emit("closeSnackbar", value)
      }
    }
  },

  methods: {
    setSnackbar() {
      const selectedType = this.Types.find(type => type.Code === this.snackbar.code)
      if (selectedType) {
        this.model.color = selectedType.Color
        this.model.title = selectedType.Title
        this.model.icon = selectedType.Icon
        this.model.iconColor = selectedType.IconColor
      }
      this.model.message = this.snackbar.message
    }
  }
})
</script>

<style scoped>
.modern-toast :deep(.v-snackbar__wrapper) {
  min-width: 360px;
  max-width: 480px;
  background: white !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
  padding: 0 !important;
}

.modern-toast :deep(.v-snackbar__content) {
  padding: 0 !important;
}

.toast-content {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
}

.toast-icon-wrapper {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
}

.toast-success {
  background: rgba(76, 175, 80, 0.1);
}

.toast-error {
  background: rgba(244, 67, 54, 0.1);
}

.toast-warning {
  background: rgba(255, 152, 0, 0.1);
}

.toast-info {
  background: rgba(33, 150, 243, 0.1);
}

.toast-text {
  flex: 1;
  min-width: 0;
}

.toast-title {
  font-weight: 600;
  font-size: 0.9375rem;
  color: #1a202c;
  margin-bottom: 0.25rem;
}

.toast-message {
  font-size: 0.875rem;
  color: #4a5568;
  line-height: 1.4;
  word-wrap: break-word;
}

.toast-close {
  flex-shrink: 0;
  color: #718096 !important;
  margin-top: -0.25rem;
  margin-right: -0.5rem;
}

.toast-close:hover {
  background: rgba(0, 0, 0, 0.05) !important;
}

/* Animation */
.modern-toast :deep(.v-snackbar__wrapper) {
  animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>